import Login from '@/views/auth/Login'
import Email from '@/views/auth/Email'
import Reset from '@/views/auth/Reset'

export default [
    {
        path: '/login',
        name: 'login',
        component: Login,
    },
    {
        path: '/password/email',
        name: 'email_password',
        component: Email,
    },
    {
        path: '/password/reset/:token',
        name: 'reset_password',
        component: Reset,
    }, 
]
